/**
 * Display label for the clinic's structured hours (site-settings hoursOpens /
 * hoursCloses / hoursDays, P8p) — «Δευτέρα–Παρασκευή, 09:00–21:00».
 *
 * The sidebar card used a hardcoded locale key for this; now the ONE
 * admin-editable source feeds schema and display alike. Returns null when the
 * structured fields are not set, so callers can fall back to the locale key.
 */
const DAY_NAMES: Record<string, { el: string; en: string; order: number }> = {
  monday: { el: "Δευτέρα", en: "Monday", order: 1 },
  tuesday: { el: "Τρίτη", en: "Tuesday", order: 2 },
  wednesday: { el: "Τετάρτη", en: "Wednesday", order: 3 },
  thursday: { el: "Πέμπτη", en: "Thursday", order: 4 },
  friday: { el: "Παρασκευή", en: "Friday", order: 5 },
  saturday: { el: "Σάββατο", en: "Saturday", order: 6 },
  sunday: { el: "Κυριακή", en: "Sunday", order: 7 },
};

export const hoursLabel = (
  footer: { hoursOpens?: string; hoursCloses?: string; hoursDays?: string } | undefined,
  locale: string
): string | null => {
  if (!footer?.hoursOpens || !footer.hoursCloses || !footer.hoursDays) return null;
  const lang = locale === "en" ? "en" : "el";
  const days = footer.hoursDays
    .split(",")
    .map((d) => DAY_NAMES[d.trim().toLowerCase()])
    .filter(Boolean)
    .sort((a, b) => a.order - b.order);
  if (!days.length) return null;

  // a contiguous run reads as a range («Δευτέρα–Παρασκευή»); anything else
  // (e.g. Mon-Wed-Fri) lists the days out
  const contiguous = days.every((d, i) => i === 0 || d.order === days[i - 1].order + 1);
  const dayPart = days.length === 1
    ? days[0][lang]
    : contiguous
      ? `${days[0][lang]}–${days[days.length - 1][lang]}`
      : days.map((d) => d[lang]).join(", ");
  return `${dayPart}, ${footer.hoursOpens}–${footer.hoursCloses}`;
};
